/**
 * 商品管理
 */
import type { PageContext } from '@zto/zpage'
import { addEditDialog, logDialog } from './_dialogs'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import dayjs from 'dayjs'
import { RbacRoleScopeType } from '@/config/enums'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/cabinet/admin/pms/AdminPmsProductQueryController/page'
      },
      add: {
        label: '新增商品',
        api: '/cabinet/admin/pms/AdminPmsProductCommandController/add',
        dialog: addEditDialog(false),
        successMessage: '新增成功！'
      },
      edit: {
        label: '编辑',
        api: '/cabinet/admin/pms/AdminPmsProductCommandController/edit',
        dialog: addEditDialog(true),
        successMessage: '编辑成功！'
      },
      log: {
        label: '日志',
        dialog: logDialog
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      items: [
        { type: 'input', prop: 'supplier', label: '供应商', span: 6,
          dynamicAttrs: ({ data, app }: PageContext) => {
            const basic = app.stores.userStore?.data?.basic || {}
            console.info('🚀 ~ file:index method:dynamicAttrs line:42 ----- basic', basic)
            return {
              default: basic.belongType === RbacRoleScopeType.SUPPLIER ? basic.supplierOrgName : '',
              disabled: basic.belongType === RbacRoleScopeType.SUPPLIER
            }
          }
        },
        { type: 'input', prop: 'productCode', label: '商品编码', span: 6 },
        { type: 'input', prop: 'productName', label: '商品名称', span: 6 }
      ]
    },
    toolbar: {
      noExport: true,
      items: [{ action: 'add' }]
    },
    table: {
      operation: {
        width: 100,
        items: [{ action: 'edit' }, { action: 'log' }]
      },
      columns: [
        { label: '商品编号', prop: 'productCode', minWidth: 180 },
        { label: '商品名称', prop: 'productName', minWidth: 150 },
        { label: '供应商', prop: 'supplierName', minWidth: 150 },
        { label: '规格', prop: 'productSpec', minWidth: 200 },
        { label: '成本价（元）', prop: 'costPrice', minWidth: 130 },
        { label: '销售价（元）', prop: 'salePrice', minWidth: 130 },
        { label: '划线价（元）', prop: 'linePrice', minWidth: 130 },
        { label: '创建人', prop: 'creator', minWidth: 150 },
        {
          label: '创建时间',
          prop: 'gmtCreate',
          minWidth: 150,
          formatter: (row: any) => {
            return dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') // 时间格式化
          }
        }
      ]
    }
  }
}
